import {
	GQLMerchDecorationFragment,
	GQLMerchItemFragment,
	GQLMerchTileFragment,
	GQLProductColourFragment,
	GQLProductSideSideType,
	GQLStoreIntegrationProductFragment,
} from '@theprintbar/graphql';
import { invariant } from '../../utils';
import { getSortedColours } from '../product';

type Decoration =
	| GQLMerchDecorationFragment
	| { side?: { side: GQLProductSideSideType | string | null } | null; isMainDecoration?: boolean | null };

export function getSortedMerchDecorations<T extends Decoration>(merch: { decorations: T[] }) {
	const newDecs = [...merch.decorations];
	const sortOrder = [
		GQLProductSideSideType.Front,
		GQLProductSideSideType.Back,
		GQLProductSideSideType.Left,
		GQLProductSideSideType.Right,
		GQLProductSideSideType.Label,
	];

	invariant(newDecs.length > 0, 'Merch must have decorations');
	//Return the merch sides in the order of the sortOrder array
	return newDecs.sort((a, b) => {
		if (a.isMainDecoration) return -1;
		if (b.isMainDecoration) return 1;
		if (!a.side?.side || !b.side?.side) return 0;

		invariant(a.side && b.side, 'Sides must have a side');
		return sortOrder.indexOf(a.side.side as GQLProductSideSideType) - sortOrder.indexOf(b.side.side as GQLProductSideSideType);
	});
}

export function getMerchPreferredColourCode(merch: GQLMerchItemFragment, linkedProduct?: GQLStoreIntegrationProductFragment) {
	const linkedColours = getSortedColours(
		linkedProduct?.variants?.reduce((acc, { variant }) => {
			if (!acc.find(c => c.id === variant.colour.id)) {
				acc.push(variant.colour);
			}
			return acc;
		}, [] as GQLProductColourFragment[]) || [],
	);

	return (
		linkedColours.find(colour => colour.colour.code === merch.preferedColourCode)?.colour.code ||
		linkedColours[0]?.colour.code ||
		merch.preferedColourCode ||
		getSortedColours(merch.product.colours)[0]?.colour.code
	);
}
